import React from 'react';

import {
  PAYMENT_TYPE_OPTIONS,
  PRIOR_AUTH_OPTIONS,
  PRIOR_AUTH_OPTIONS_LIST
} from '@/constants/treatability';
import AutocompleteSingleSelect from '@/ui/components/AutocompleteSingleSelect';
import Input from '@/ui/components/Form/InputField';
import { OptionType } from '@/ui/components/Form/Select/types';
import Modal from '@/ui/components/Modal';

import type { Props } from './types';

const BulkEditModal = ({ open, onClose, data, onChange, onSubmit, selectedCount }: Props) => (
  <Modal
    open={open}
    onClose={onClose}
    overflowVisible
    title={`Edit ${selectedCount} Selected Match${selectedCount !== 1 ? 'es' : ''}`}
    button={{ children: 'Save Changes', onClick: onSubmit }}
    dismissButton={{ children: 'Cancel', onClick: onClose }}>
    <div className="mt-4 space-y-4">
      <AutocompleteSingleSelect
        label="Payment Type"
        options={PAYMENT_TYPE_OPTIONS}
        selectedOption={data.payment_type}
        onChange={(val) => onChange({ ...data, payment_type: val })}
        placeholder="No change"
        debounce={false}
      />

      <div>
        <Input
          id="bulk-edit-active-on"
          label="Active On"
          type="date"
          value={data.active_on}
          onChange={(e) => onChange({ ...data, active_on: e.target.value })}
        />
        {data.active_on && !data.active_until && (
          <p className="mt-1 text-xs text-gray-500">
            Active Until will be cleared for any records where the existing end date falls on or
            before this date.
          </p>
        )}
      </div>

      <Input
        id="bulk-edit-active-until"
        label="Active Until"
        type="date"
        value={data.active_until}
        onChange={(e) => onChange({ ...data, active_until: e.target.value })}
      />

      <AutocompleteSingleSelect
        label="Prior Auth Required"
        options={PRIOR_AUTH_OPTIONS_LIST}
        selectedOption={data.prior_auth_required}
        onChange={(val) =>
          onChange({ ...data, prior_auth_required: val as OptionType<PRIOR_AUTH_OPTIONS> | null })
        }
        placeholder="No change"
        debounce={false}
      />
    </div>
  </Modal>
);

export default React.memo(BulkEditModal);
